import { EventEmitter, Injectable } from '@angular/core';
import * as MomentJS from 'moment';
import { Subscription } from 'rxjs';

const Moment = MomentJS;

@Injectable({
  providedIn: 'root'
})
export class DateUtilsService {

  record: any = {};
  objectEmitter = new EventEmitter();
  objectSubscription: Subscription;

  static months:any = {
    short: ["jan", "feb", "mar", "apr", "may", "jun", "jul", "aug", "sep", "oct", "nov", "dec"],
    long: ["january", "february", "march", "april", "may", "june", "july", "august", "september", "october", "november", "december"]
  };

  static weeks:any = {
    short: ['mon', 'tue', 'wed', 'thu', 'fri', 'sat', 'sun'],
    long: ['monday', 'tuesday', 'wednesday', 'thursday', 'friday', 'saturday', 'sunday'],
  };

  static filterModes:any[] = [
    {label: "Today", value:"today"},
    {label: "Yesterday", value:"yesterday"}
  ];

  generateDisplayColumnsFilter(filterMode:string){

    let lstDisplays = [];
    if (filterMode == "yesterday") {
      lstDisplays.push(Moment(new Date()).subtract(1, 'days').format("YYYY-MM-DD"));
    }
 
    if (filterMode == "today") {
      lstDisplays.push(Moment(new Date()).format("YYYY-MM-DD"));
    }

    /** last week */
    if (filterMode == "last_week" || filterMode == "this_week") {
      lstDisplays = DateUtilsService.weeks.long;
    }

    /** last month */
    if (filterMode == "last_month") {
      let month:string = `${Moment().subtract(1, 'months').startOf('months').format("MM")}`;
      let year:string = `${Moment().subtract(0, 'years').startOf('years').format("YYYY")}`;
      lstDisplays = DateUtilsService.getListDays(month, year);
    }

    /** This month */
    if (filterMode == "this_month") {
      let month:string = `${Moment().subtract(0, 'months').startOf('months').format("MM")}`;
      let year:string = `${Moment().subtract(0, 'years').startOf('years').format("YYYY")}`;
      lstDisplays = DateUtilsService.getListDays(month, year);
    }
 
    if (filterMode == "this_year") {
      let year:string = `${Moment().subtract(0, 'years').startOf('years').format("YYYY")}`;

      DateUtilsService.months.short.forEach(month => {
        lstDisplays.push(`${month}-${year}`);
      }); 
    }

    if (filterMode == "last_year") {
      let year:string = `${Moment().subtract(1, 'years').startOf('years').format("YYYY")}`;

      DateUtilsService.months.short.forEach(month => {
        lstDisplays.push(`${month}-${year}`);
      }); 
    }

    return lstDisplays;
  
  }
  /**
   * 
   * @param fieldname     object field date name that want to compare
   * @param filterMode    Date filter mode e.g. today, yesterday, this_month (value take it from filterMode variable above)
   * @param dateValues     object that store date value
   *                      filterMode = custom_date, dateValue = {sdate: 'YYYY-MM-DD'}
   *                      filterMode = custom_date_rank, dateValue = {sdate: 'YYYY-MM-DD', edate: 'YYYY-MM-DD'}
   * @returns 
   */
  generateObjectFilter(fieldname:string, filterMode:string, dateValues?:any){
    let filter:any = {};
    let hasFilter:boolean = false;

    if (filterMode == "yesterday") {
      filter[`date__${fieldname}`] = Moment(new Date()).subtract(1, 'days').format("YYYY-MM-DD"); 
      hasFilter = true;
    }
 
    if (filterMode == "today") {
      filter[`date__${fieldname}`] = Moment(new Date()).format("YYYY-MM-DD"); 
      hasFilter = true;
    }

    /** last week */
    if (filterMode == "last_week") {
      filter[`diff__${fieldname}`] = `${Moment().subtract(1, 'weeks').startOf('week').format("YYYY-MM-DD")},${Moment().subtract(1, 'weeks').endOf('week').format("YYYY-MM-DD")}`;
      hasFilter = true;
    }

    /** This week */
    if (filterMode == "this_week") {
      filter[`diff__${fieldname}`] = `${Moment().subtract(0, 'weeks').startOf('week').format("YYYY-MM-DD")},${Moment().subtract(0, 'weeks').endOf('week').format("YYYY-MM-DD")}`;
      hasFilter = true;
    }

    /** last month */
    if (filterMode == "last_month") {
      filter[`month__${fieldname}`] = `${Moment().subtract(1, 'months').startOf('months').format("MM")}`;
      filter[`year__${fieldname}`] = `${Moment().subtract(0, 'years').startOf('years').format("YYYY")}`;
      hasFilter = true;
    }

    /** This month */
    if (filterMode == "this_month") {
      filter[`month__${fieldname}`] = `${Moment().subtract(0, 'months').startOf('months').format("MM")}`;
      filter[`year__${fieldname}`] = `${Moment().subtract(0, 'years').startOf('years').format("YYYY")}`;
      hasFilter = true;
    }
 
    if (filterMode == "this_year") {
      filter[`year__${fieldname}`] = `${Moment().subtract(0, 'years').startOf('years').format("YYYY")}`; 
      hasFilter = true;
    }
 
    if (filterMode == "custom_date" && dateValues && dateValues.sdate) {
      filter[`date__${fieldname}`] = Moment(new Date(dateValues.sdate)).format("YYYY-MM-DD");
      hasFilter = true;
    }

    if (filterMode == "custom_date_rank" && dateValues && dateValues.sdate && dateValues.edate) {
      filter[`dge__${fieldname}`] = Moment(new Date(dateValues.sdate)).format("YYYY-MM-DD");
      filter[`dle__${fieldname}`] = Moment(new Date(dateValues.edate)).format("YYYY-MM-DD");
      hasFilter = true;
    }

    return hasFilter ? filter: null;
  }

  static getListDays(month:string, year:string):string[]{
    let fetchMonth = ("0" + month).slice(-2);//make sure always 2 digits
    let numberOfDay = Moment(`${year}-${fetchMonth}`, "YYYY-MM").daysInMonth();
    let lstDays:string[] = [];

    for (let i = 1; i <= numberOfDay; i++){
      let day:string =  ("0" + i).slice(-2);
      lstDays.push(`${day}-${fetchMonth}-${year}`);
     
    }
    return lstDays;
  }


  // For toggle change date service
  /**
   * 
   * @param formAction 
   * @param mode 
   * @param option     {sdate: "YYYY-MM-DD", label: ""}
   */
   setValue(formAction: string, mode: string, option?: any) {
    this.record.formAction = formAction ? formAction : "";
    this.record.mode = mode ? mode : "";
    this.record.option = option ? option : "";
    // console.log("record service", this.record);
    
    this.objectEmitter.emit(this.record);
  }

  getValue() {
    return this.record;
  }
}
